<template>
  <div class="progress-circle">
    <canvas ref="canvas" width="100" height="100"></canvas>
    <div class="percentage">{{ Math.round(percentage) }}%</div>
  </div>
</template>

<script>
import { ref, watch, onMounted } from "vue";
export default {
  props: {
    percentage: {
      type: Number,
      required: true
    }
  },
  setup(props) {
    const canvas = ref(null);
    
    const drawProgressCircle = () => {
      const ctx = canvas.value.getContext("2d");
      const radius = 40;
      const lineWidth = 10;
      const center = 50;
      const percentage = props.percentage;

      ctx.clearRect(0, 0, 100, 100);

      ctx.beginPath();
      ctx.arc(center, center, radius, 0, 2 * Math.PI);
      ctx.lineWidth = lineWidth;
      ctx.strokeStyle = "#e6e6e6";
      ctx.stroke();

      ctx.beginPath();
      ctx.arc(center, center, radius, -0.5 * Math.PI, (percentage / 100) * 2 * Math.PI - 0.5 * Math.PI);
      ctx.lineWidth = lineWidth;
      ctx.strokeStyle = "#4caf50";
      ctx.stroke();
    };

    watch(() => props.percentage, drawProgressCircle);

    onMounted(() => {
      drawProgressCircle();
    });

    return {
      canvas
    };
  }
};
</script>

<style scoped>
.progress-circle {
  position: relative;
  display: inline-block;
  width: 100px;
  height: 100px;
}

.percentage {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 18px;
  font-weight: bold;
  color: #4caf50;
}
</style>
